import type { Stock } from '../../types/stock';
import type { ActivityFilters } from '../activity/types';

export const StockSelectionMode = {
  STOCK_VIEW: 'STOCK_VIEW',
  SINGLE_STOCK_SELECTION: 'SINGLE_STOCK_SELECTION',
  MULTIPLE_STOCK_SELECTION: 'MULTIPLE_STOCK_SELECTION',
} as const;

export type StockSelectionMode = typeof StockSelectionMode[keyof typeof StockSelectionMode];

export const isStockView = (mode: StockSelectionMode): boolean => 
  mode === StockSelectionMode.STOCK_VIEW;

export const isSingleStockSelection = (mode: StockSelectionMode): boolean => 
  mode === StockSelectionMode.SINGLE_STOCK_SELECTION;

export const isMultipleStockSelection = (mode: StockSelectionMode): boolean => 
  mode === StockSelectionMode.MULTIPLE_STOCK_SELECTION;

export const isSelectionMode = (mode: StockSelectionMode): boolean => 
  isSingleStockSelection(mode) || isMultipleStockSelection(mode);

export interface StockSelectionContext {
  mode: StockSelectionMode;
  activityFeId?: string;
  currentStockId?: number;
  returnPath?: string;
  returnStateKey?: string; // For dynamic state keys like 'selectedStockFrom'
  // Спільний об'єкт фільтрів активностей
  activityFilters?: ActivityFilters;
}

export interface StockSelectionResult {
  selectedStock?: Stock;
  selectedStocks?: Stock[];
  activityFeId?: string;
}
